<template>
  <div class="basic_wrap">
    <div class="order-record-header">
      <div
        class="order-record-back"
        @click="$router.back()"
      />
      <div class="order-record-title">
        {{ $t('shopd.otitle') }}
      </div>
      <!-- <div class="top_right" @click="$router.push('/moneybag')">
				<van-icon name="bars" size="25"/>
			</div> -->
    </div>
    <div class="head-tabs shadow">
      <a
        href="#/ordering"
        class="tab-item "
      >{{ $t('shopd.Ordering') }}</a>
      <a
        href="#/ordered"
        class="tab-item "
      >{{ $t('shopd.done') }}</a>
      <a
        href="#/ordersettle"
        class="tab-item active"
      >{{ $t('c3.settlement') }}</a>
      <a
        href="#/orderfrezee"
        class="tab-item "
      >{{ $t('c3.frezee') }}</a>
    </div>
    <!-- 	<div v-if="data" class="empty" >
		    <div class="image"><img src="../images/shop2/empty.png"></div>
		    <a href="#/grap" class="basic_btn">{{$t('shopd.grabbing')}}</a>
		</div> -->
		
		
    <van-empty
      v-if="!list"
      :description="$t('orders.noOrders')"
    />
    <div
      v-if="!list"
      class="basic_btn"
      @click="$router.push('/grap')"
    >
      {{ $t('shopd.grabbing') }}
    </div>
		
    <div
      v-for="i in list"
      v-if="list"
      class="order_list1"
    >
      <div class="list_top1">
        <img :src="orderImage(i.pic)">
        <div class="list_text1">
          <span>{{ i.title }}</span>
          <div>
            <p>{{ i.pri }}</p>
            <p>X{{ i.num }}</p>
          </div>
        </div>
      </div>
      <div class="list_down1">
        <div class="list_down">
          <div>
            <span>{{ $t('shopds.onum') }}</span>
            <span>{{ i.no }}</span>
          </div>
          <div>
            <span>{{ $t('shopds.money') }}</span>
            <span>{{ i.price }}</span>
          </div>
          <div>
            <span>{{ $t('shopds.needba') }}</span>
            <span>{{ i.need }}</span>
          </div>
          <div>
            <span>{{ $t('shopds.income') }}</span>
            <span class="income-value">{{ i.fee }}</span>
          </div>
				
          <!--  <div >
		                <span>{{$t('shopds.numtask')}}</span>
		                <span>{{i.level}}</span>
		            </div> -->
          <div>
            <span>{{ $t('shopds.time') }}</span>
            <span>{{ i.ct }}</span>
          </div>
          <div
            v-if="i.stat==98 || (i.stat==99 && i.pay=='0')"
            class="notice"
          >
            <span>
              <van-badge
                color="#d2d214"
                content="Frezee"
              />
            </span>
            <span><van-icon
              name="warning-o"
              size="20"
              color="#d2d214"
            /></span>
          </div>
          <div
            v-if="i.stat==0"
            class="notice"
          >
            <span>
              <van-badge
                color="#999"
                content="Undo"
              />
            </span>
            <span><van-icon
              name="warning-o"
              size="20"
              color="#999"
            /></span>
          </div>
          <div v-if="i.stat==100 || i.stat==101">
            <span>
              <van-badge
                color="#3f9a43"
                content="Completed"
              />
            </span>
            <span><van-icon
              name="passed"
              size="20"
              color="#3f9a43"
            /></span>
          </div>
        </div>
        <div
          v-if="i.stat==50"
          class="basic_btn"
          @click.stop="data = i;show = true"
        >
          {{ $t('shopd.completeorder') }}
        </div>
      </div>
    </div>
    <div
      v-if="data"
      class="payment-all"
    >
      <div>Amount: $  {{ data.price }}</div>
      <div>
        <button
          class="btnsub"
          @click.stop="show = true"
        >
          {{ $t('shopd.completeorder') }}
        </button>
      </div>
    </div>
    <div
      v-if="data"
      class="payment-time"
    >
      <div>
        Payment countdown: 
        <van-count-down
          style="display: initial; font-size: 12px; "
          :auto-start="true"
          :time="time"
          format="HH:mm:ss"
        />
      </div>
    </div>
		
		
    <van-overlay
      :show="show"
      @click="show = false"
    >
      <div
        class="wrapper"
        @click.stop
      >
        <div
          v-if="data"
          class="pop_box"
        >
          <div class="order_cards">
            <div class="order_list1">
              <div class="list_top1">
                <img :src="orderImage(data.pic)">
                <div class="list_text1">
                  <span>{{ data.title }}</span>
                  <div>
                    <p>{{ data.price }}</p>
                    <p>X1</p>
                  </div>
                </div>
              </div>
              <div class="list_down1">
                <div class="list_down">
                  <div>
                    <span>{{ $t('shopds.onum') }}</span>
                    <span>{{ data.no }}</span>
                  </div>
                  <div>
                    <span>{{ $t('shopds.money') }}</span>
                    <span>{{ data.price }}</span>
                  </div>
                  <div>
                    <span>{{ $t('shopds.needba') }}</span>
                    <span>{{ data.need }}</span>
                  </div>
                  <div>
                    <span>{{ $t('shopds.income') }}</span>
                    <span class="income-value">{{ data.fee }}</span>
                  </div>
                  <div>
                    <span>{{ $t('shopds.numtask') }}</span>
                    <span>{{ data.level }}</span>
                  </div>
                  <div>
                    <span>{{ $t('shopds.time') }}</span>
                    <span>{{ data.ct }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="capital_evaluate">
            <span>{{ $t('shopds.score') }}</span>
            <van-rate
              v-model="star"
              clearable
            />
          </div>
          <div
            class="pop_but"
            @click="doorder()"
          >
            <span><span>{{ $t('shopds.deal') }}</span></span>
          </div>
          <div
            class="pop_but second"
            @click="show = false"
          >
            <span><span>{{ $t('shopd.cancelbtn') }}</span></span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
    var _that;
	import {
		Dialog,Rate,Overlay,Badge
	} from 'vant';
	import Fetch from "../../utils/fetch";
	import { resolveSiteImage } from "../../utils/site-image";
	Vue.use(Empty)
	.use(Rate)
	.use(Badge)
	.use(Overlay);
	export default {
		name: "Ordering",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				siteDomain: '',
				data:null,
				list:null,
				show:false,
				star:0,
				time:0,
				doing:0
			};
		},
		created() {
			this.$parent.footer("ordering");
		},
		mounted() {
			this.start();
			Fetch('/index/webconfig').then((response) => {
				this.siteDomain = (response.data && response.data.domain) || '';
			}).catch(() => {});
			_that = this;
		},
		beforeDestroy() {
		    _that.doing = 0;
		},
		methods: {
			orderImage(image) {
				return resolveSiteImage(image, this.siteDomain);
			},
			start() {
				Fetch("/user/ordersettle").then((r) => {
					if(r.data && r.data.length>0){
						this.list = r.data;
						var data = r.data[0];
						if(data.stat==50){
							var currentTimestamp = Date.now()/1000;
							var time = (data.rt-currentTimestamp)*1000;
							if(time<0){
								time=0;
							}
							this.time=time;
							this.data = data;
						}
					}
				});
			},
			doorder(){
				if(this.star<3){
					this.$toast({
						duration:'3000',
						background: '#07c160',
						message: this.$t('shopds.lowscore')
					});
					return false;
				}
				
				Fetch("/user/doorder", {
				  id: this.data.id
				}).then(r => {
					// showDialog({
					//   message: this.$t('shopd.corder'),
					//   theme: 'round-button',
					// }).then(() => {
					//   this.$router.push('/grap');
					// });
					this.show = false;
					this.$toast({
						duration:'3000',
						background: '#07c160',
						message: this.$t('shopd.corder')
					});
					this.$router.push('/grap');
				}).catch(err=>{
					if(err && err.code==0 && err.data && err.data.need){
						Dialog.confirm({
							title: 'Tips',
							confirmButtonText:this.$t('moneybag.recharge'),
							cancelButtonText:this.$t('shopd.cancelbtn'),
							message: this.$t('shopds.need') + " " +this.utils_moneyMark()+ err.data.need.toFixed(2)
						})
						.then(() => {
						  this.$router.push('/invest');
						})
						.catch(() => {
						});
					}
				})
			},
			receiveRewards(item){
				var index = -1;
				 for(var i=0;i<this.data.list.length;i++){
					if(this.data.list[i].id==item.id){
						index =i;
					}
				}
				
				Fetch("/index/receiveRewards", {
				  id: item.id
				}).then(r => {
					Dialog.alert({
						message: window.vm.$i18n.t('item.getincome')+ r.data.price,
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					});
					
					this.data.list[index].isling = '0'
					var sysdate = new Date(r.data.sys_date);
					var millSeconds = Math.abs(sysdate) + (1000*60*60*24-1);
					var date1 = new Date(millSeconds);
					var M = (date1.getMonth()+1 < 10 ? '0'+(date1.getMonth()+1) : date1.getMonth()+1) + '-';		
					var sysTime = sysdate.getFullYear() + '-' + M + sysdate.getDate() + ' '+ sysdate.getHours() + ':' + sysdate.getMinutes() + ':' + sysdate.getSeconds();			 
					var countTime = date1.getFullYear() + '-' + M + date1.getDate() + ' '+ date1.getHours() + ':' + date1.getMinutes() + ':' + date1.getSeconds();
					this.data.list[index].sys_time = sysTime;
					this.data.list[index].count_time = countTime;
				}).catch(err=>{
					Dialog.alert({
						message: window.vm.$i18n.t('item.getincomefail'),
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					});
				})
			}
		},
	};
</script>

<style lang="less" scoped>
@import './order-record-theme.less';
</style>
